// Utils for mobile device detection to server PWA routes
/**
 * Detects if the app is running as a PWA (installed app)
 * @returns {boolean} true if running as PWA
 */
export const isPWA = () => {
    // Check if running in standalone mode (iOS Safari)
    if (window.navigator.standalone === true) {
        return true;
    }

    // Check if running in standalone mode (Android Chrome)
    if (window.matchMedia('(display-mode: standalone)').matches) {
        return true;
    }

    // Check if running in minimal-ui mode
    if (window.matchMedia('(display-mode: minimal-ui)').matches) {
        return true;
    }

    // Additional check for PWA context
    if (document.referrer.startsWith('android-app://')) {
        return true;
    }

    return false;
};

/**
 * Detects if device is mobile
 * @returns {boolean} true if mobile device
 */
export const isMobileDevice = () => {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ||
        window.innerWidth <= 768;
};

/**
 * Checks if app should use PWA mode (PWA + mobile)
 * @returns {boolean} true if should use PWA mode
 */
export const shouldUsePWAMode = () => {
    return isPWA() && isMobileDevice();
};